import { apiGet, apiPost } from "../fetch";
import type { IntroPace } from "./intro-enrolment";

export type IntroStatus =
	| "pending"
	| "sent"
	| "replied"
	| "closed"
	| "converted"
	| "skipped";

/** Whether Yes put a message on its way that has not gone out yet. */
export type IntroSendState = "none" | "queued" | "failed";

/** How much the customer has written with the lead: counts and a date, never content. */
export interface IntroTie {
	channel: "LinkedIn" | "email";
	count: number;
	last_at: string | null;
}

/** One lead this week: a LinkedIn connection of the customer, up-voted by Artemis staff. */
export interface IntroLead {
	id: number;
	name: string;
	first_name: string;
	title: string | null;
	company: string | null;
	headline: string | null;
	linkedin_url: string | null;
	tie: IntroTie | null;
	status: IntroStatus;
	/** What was sent once answered; before that the template rendered for this lead. */
	intro_text: string;
	/** False while this lead's role has no intro template: Yes is refused. */
	can_send: boolean;
	send_state: IntroSendState;
	send_error: string | null;
	sent_at: string | null;
	conversation_url: string | null;
}

export interface IntroWeek {
	enrolled: true;
	week: string;
	pace: IntroPace;
	paused: boolean;
	staff_first_name: string;
	/** Set when the screening role has no intro template: nothing can be sent. */
	template_error: string | null;
	leads: IntroLead[];
}

export type IntroWeekResponse = IntroWeek | { enrolled: false };

const URL = "/api/v2/intro-program/";

export function fetchIntroWeek(): Promise<IntroWeekResponse> {
	return apiGet(`${URL}this-week/`) as Promise<IntroWeekResponse>;
}

export function sendIntro(id: number, introText: string): Promise<IntroLead> {
	return apiPost(`${URL}requests/${id}/yes/`, {
		intro_text: introText,
	}) as Promise<IntroLead>;
}

export function skipIntro(id: number): Promise<IntroLead> {
	return apiPost(`${URL}requests/${id}/skip/`, {}) as Promise<IntroLead>;
}
